import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon';
import styles from './Select.module.scss';

export interface OptionProps {
	value: string | undefined;
	displayName: string;
}

export type CtaGroupPosType = 'left' | 'center' | 'right';

interface SelectProps {
	className?: string;
	name?: string;
	id?: string;
	value: string;
	options: OptionProps[];
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	ariaLabel?: string;
	disabled?: boolean;
	variant?: 'default' | 'inverse';
	errorText?: string;
	ctaGroupPos?: CtaGroupPosType;
}

/**
 * Generic Select component, used for select input components.
 * NOT for navigation links, but for submitting user input.
 * For navigation, please see Dropdown.
 */
export const Select: React.FunctionComponent<SelectProps> = ({
	className,
	name,
	id,
	value,
	ariaLabel,
	options,
	onChange,
	disabled,
	variant,
	errorText,
	ctaGroupPos,
}) => {
	return (
		<div className={classNames(styles.wrapper, className)}>
			<select
				className={classNames(styles.select, ctaGroupPos && 'u-cta-group-' + ctaGroupPos, {
					[styles.hasError]: !!errorText?.length,
					[styles.isInverse]: variant === 'inverse',
				})}
				name={name}
				id={id}
				value={value}
				aria-label={ariaLabel || name}
				disabled={disabled}
				onChange={onChange}
			>
				{options &&
					options.map((option) => (
						<option value={option.value} key={option.value ?? option.displayName}>
							{option.displayName}
						</option>
					))}
			</select>
			<Icon className={styles.icon} name={'arrowLeft'} rotate={'270'} size={'md'} />
		</div>
	);
};
